<template>
    <div class="scroll_top_wrapper">
        <span id="scroll_top" class="scroll_top" :class="classShow" @click.prevent="clickUp">
            <svg>
                <use xlink:href="/icons/base.svg#icon_button_up"></use>
            </svg>
        </span>
    </div>
</template>

<script>
export default {
    name: "button_up",
    emits: ['click_up'],
    props: {
        isShow: {
            type: Boolean,
            required: true,
        }
    },
    methods: {
        clickUp() {
            this.$emit('click_up');
        }
    },
    computed: {
        classShow() {
            if (this.isShow) {
                return {'show': true};
            }
            return {'show': false};
        }
    }
}
</script>

<style scoped>

</style>
